/*eslint no-var: [2] */

import PropTypes from 'prop-types';

import React from 'react';
import classnames from 'classnames';
let nextId = 0;

/*
CSS3 on/off switch from http://proto.io/freebies/onoff/
*/
class OnOffSwitch extends React.PureComponent {
    static displayName = 'OnOffSwitch';

    static propTypes = {
        // I'm not sure how to make this work as an uncontrolled input, so I'm
        // making checked required.
        checked: PropTypes.bool.isRequired,
        children: PropTypes.node.isRequired,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        onChange: PropTypes.func.isRequired,
        position: PropTypes.oneOf(['right', 'left']),
    };

    static defaultProps = {
        className: '',
        position: 'right',
        disabled: false,
    };

    state = {
        uniqueId: 'on-off-switch-' + nextId++,
    };

    render() {
        const { uniqueId } = this.state;

        const classes = classnames('toggle-group', this.props.position, {
            disabled: this.props.disabled,
        });

        const switchClasses = classnames('onoffswitch', this.props.className, {
            'pull-right': this.props.position === 'right',
        });

        return (
            <div className={classes}>
                <input
                    disabled={this.props.disabled}
                    type="checkbox"
                    id={uniqueId}
                    checked={this.props.checked}
                    onChange={this.props.onChange}
                />

                <label htmlFor={uniqueId}>{this.props.children}</label>
                <div className={switchClasses} aria-hidden="true">
                    <div className="onoffswitch-label">
                        <div className="onoffswitch-inner" />
                        <div className="onoffswitch-switch" />
                    </div>
                </div>
            </div>
        );
    }
}

export default OnOffSwitch;



// WEBPACK FOOTER //
// ./src/components/on_off_switch.jsx